var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatroom-scoll",attrs:{"id":"message-area"}},_vm._l((_vm.message),function(item){return _c('message-item',{key:item.id,attrs:{"item":item,"id":"item.id"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }